import React, { useState } from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import Lable from "../Lable/Lable";
import ListItem from "../List-Item/ListItem";
import { AllRequestData } from "../../Utils/Data";

export default function AllRequestTable() {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  const [Header] = useState([
    "ردیف",
    "کد درخواست",
    "عنوان درخواست",
    "گیرنده",
    "وضعیت",
    "ضمیمه",
    "عملیات",
  ]);

  const [LableInfo] = useState(AllRequestData)

  const width = "12rem";
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;

  const nextPageHandler = function () {
    setCurrentPage((data) => {
      if (LableInfo?.length > (data + 1) * postsPerPage - postsPerPage)
        return ++data;

      return data;
    });
  };

  const previousPageHandler = function () {
    setCurrentPage((data) => {
      if (currentPage > 1) return --data;

      return data;
    });
  };

  return (
    <Container>
      <ListContainer>
        <Lable props={{ ...Header }} width={width} />
        {LableInfo.slice(firstPostIndex, lastPostIndex).map((data) => {
          return <ListItem key={data.id} props={{ ...data }} width={width} />;
        })}
      </ListContainer>
      <ListButton>
        <Icon
          src="/Assets/Images/prePage.svg"
          onClick={() => previousPageHandler()}
        ></Icon>
        <Text>{`صفحه ${currentPage} از ${Math.ceil(LableInfo?.length/postsPerPage)}`}</Text>
        <Icon
          src="/Assets/Images/nextPage.svg"
          onClick={() => nextPageHandler()}
        ></Icon>
      </ListButton>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
`;

const ListContainer = styled.div`
  width: 100%;
  display: block;
`;

const ListButton = styled.button`
  margin: 0.5rem auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${Theme.colorBluePrimary};
  border-radius: ${Theme.borderRadius};
  border: none;
  padding: 0.5rem;
`;

const Icon = styled.img`
  width: 1rem;
  height: 1rem;
  margin: 0.7rem;
  cursor: pointer;
`;

const Text = styled.p`
  font-family: "IranSans";
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontWeigh};
  color: ${Theme.colorFontWhite};
  margin: 0;
  padding: 0 1rem;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  border-left: 1px solid rgba(255, 255, 255, 0.3);
`;

